import {IRouteStore} from '../../router/routing.infra';
import {getRootStore} from '../../app.bootstrap';
import {RouteName} from '../../router/route-names';
import {ConnectivityController} from './ConnectivityController';
import {IConnectivityControllerDependencies} from './ConnectivityController';

export interface IConnectivityControllerIframeHelper {
    getIframeSrc(): string;
    goToInvite(): void;
    isIE: boolean;
}

/** Alias for Connectivity.tsx compatibility */
export type IConnectivityControllerAngular = IConnectivityControllerIframeHelper;

class ConnectivityIframeHelper implements IConnectivityControllerIframeHelper {
    private _accountId: string;
    private _stateHelper: any;
    private _auth: any;
    public isIE: boolean;
    private _username: string;

    constructor(accountData: any, tsStateHelper: any, currentUser: any) {
        const rootStore = getRootStore();
        this._accountId = accountData._id;
        this._stateHelper = tsStateHelper;
        this._username = currentUser.userName;
        this._auth = rootStore.authService;
        this.isIE = rootStore.environmentService.isIE11();
    }

    getIframeSrc(): string {
        const token = this._auth.getAuthToken();
        return `/connectivity.html#accountId=${this._accountId}&token=${token}&username=${this._username}`;
    }

    goToInvite(): void {
        void this._stateHelper.navigateTo(RouteName.INVITE);
    }
}

export interface IConnectivityCheckStore extends IRouteStore {
    connectivityController: ConnectivityController;
    connectivityControllerAngular: IConnectivityControllerIframeHelper;
    dispose(): void;
}

export class ConnectivityCheckStore implements IConnectivityCheckStore {
    public connectivityController: ConnectivityController;
    public connectivityControllerAngular: IConnectivityControllerIframeHelper;

    constructor(accountData: any, currentUser: any) {
        const rootStore = getRootStore();

        const deps: IConnectivityControllerDependencies = {
            accountData,
            currentUser,
            tsStateHelper: rootStore.tsReactStateHelper,
            tsUrlUtils: rootStore.browserUtilsService,
            redirectionService: rootStore.redirectionService,
            tsAppUserService: rootStore.tsAppUserService,
            authService: rootStore.authService,
            appState: rootStore.appState,
            displayTabletAsDesktop: rootStore.displayTabletAsDesktop
        };

        this.connectivityController = new ConnectivityController(deps);
        this.connectivityControllerAngular = new ConnectivityIframeHelper(
            accountData,
            rootStore.tsReactStateHelper,
            currentUser
        );
    }

    dispose(): void {
        // Cleanup if needed
    }
}
